export const Projects = [
  {
    thumbnail: "./images/Tic_tac_toe.png",
    title: "Tic-Tac-Toe",
    tags: ["HTML, CSS, Javascript, Reactjs"],
    paragraph: "A mini React.js project, Tic-Tac-Toe, is a web application that lets users enjoy the classic game either with another player or against the computer. The app features a clean, user-friendly interface where players can easily make their moves. It clearly displays the current player, updates the game status in real time, and provides instant feedback on wins, losses, or draws.",
    codelink: "https://github.com/sravanivundavalli/react-tic-tac-toe",
    projectlink: "https://tic-tac-toe.vundavalli.me/",
    projectlinkText: "View Project",
  },

  {
    thumbnail: "./images/Investment_calculator.png",
    title: "Investment Calculator",
    tags: ["HTML, CSS, Javascript, Reactjs"],
    paragraph: "The Investment Calculator mini project is a web application designed to help users estimate the future value of their investments. Users can input their initial investment amount, annual interest rate, and investment duration through a user-friendly interface. The app then calculates and displays the projected future value, making it easy for users to plan and visualize their financial growth.",
    codelink: "https://github.com/sravanivundavalli/Investment-Calculator",
    projectlink: "https://investment-calculator.vundavalli.me/",
    projectlinkText: "View Project",
  },

  {
    thumbnail: "./images/Weather_App.png",
    title: "Weather App",
    tags: ["HTML, CSS, JavaScript, React, REST API"],
    paragraph: "The Weather App project provides real-time weather information for any location worldwide. Users can search for a city and receive current weather conditions, including temperature, humidity, wind speed, and a brief description of the weather. The app utilizes a REST API to fetch data, ensuring accurate and up-to-date information. With its clean design and responsive layout, the Weather App offers an intuitive user experience.",
    codelink: "https://github.com/sravanivundavalli/Weather-App",
    projectlink: "https://weather.vundavalli.me",
    projectlinkText: "View Project",
  },

  {
    thumbnail: "./images/youtube_clone.PNG",
    title: "YouTube Clone 2.0",
    tags: ["CSS, Javascript, React, Mui "],
    paragraph:
      "YouTube Clone 2.0 is a web application that replicates the core features of YouTube, provides a user-friendly and feature-rich platform including video playback, search, user authentication, comments, likes/dislikes, subscriptions, and user profiles. By utilizing the power of React, Material-UI, and the extensive capabilities of RapidAPI, To ensure a modern and responsive design.",
    codelink: "https://github.com/sravanivundavalli/Youtube-Clone",
    projectlink: "https://youtube-clone.vundavalli.me/",
    projectlinkText: "View Project",
  },


  {
    thumbnail: "./images/portfolio.png",
    title: "My portfolio",
    tags: ["HTML, CSS, Javascript, React, Styled Components"],
    paragraph:
      "This portfolio has been meticulously designed and developed using a combination of HTML5, CSS3, and JavaScript and Styled Components. From responsive layouts to seamless interactions, I've prioritized user-centric design to ensure an engaging and enjoyable experience across various devices and screen sizes.",
    codelink: "https://github.com/sravanivundavalli/React-Portfolio",
    projectlink: "https://vundavalli.me",
    projectlinkText: "View Project",
  },

  {
    thumbnail: "./images/Booking_App.png",
    title: "Booking App",
    tags: ["HTML, CSS, Javascript, Reactjs"],
    paragraph:
      "Your Ultimate Travel Companion: Book Hotels and Flights with Ease! your one-stop solution for all your travel needs! Whether you're planning a weekend getaway, a business trip, or a dream vacation, we've got you covered with our seamless booking experience for hotels and flights.",
    codelink: "https://github.com/sravanivundavalli/Bookings-App",
    projectlink: "https://Bookings.vundavalli.me/",
    projectlinkText: "View Project",
  },
];
